import { render, staticRenderFns } from "./RedeploymentApproval.vue?vue&type=template&id=5b9fc938&scoped=true"
import script from "./RedeploymentApproval.vue?vue&type=script&lang=js"
export * from "./RedeploymentApproval.vue?vue&type=script&lang=js"
import style0 from "./RedeploymentApproval.vue?vue&type=style&index=0&id=5b9fc938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9fc938",
  null
  
)

export default component.exports